export const environment = {
  availableLangs: ['en'],
  defaultLang: 'en',
  loginType: 'user', // [user, windows]
  apiBaseUrl: 'https://fleet-test.nlbleasego.si/api/v1',
  currency: '€',
  mileage: 'km',
  replacementCarDays: [2, 3, 4, 5, 6, 7, 8, 9, 10],
  tiresNo: [0, 4, 8, 12],
  rimTypes: ['ALU', 'JEK'],
  locale: 'sl-SL',
  preset: [
    {
      serviceTypeName: 'MNGFeeNLBLG',
      isChecked: true,
      isDisabled: true,
    },
    {
      serviceTypeName: 'MNGFeeAvantCar',
      isChecked: true,
      isDisabled: true,
    },
    {
      serviceTypeName: 'ReplacementVehicle',
      isChecked: true,
      isDisabled: false,
    },
    {
      serviceTypeName: 'TiresServices',
      isChecked: true,
      isDisabled: false,
    },
    {
      serviceTypeName: 'RegistrationServices',
      isChecked: true,
      isDisabled: false,
    },
    {
      serviceTypeName: 'RoadSideAssistance',
      isChecked: true,
      isDisabled: false,
    },
    {
      serviceTypeName: 'Cleaning',
      isChecked: true,
      isDisabled: false,
    },
    {
      serviceTypeName: 'Door2Door',
      isChecked: true,
      isDisabled: false,
    },
    {
      serviceTypeName: 'InsuranceMngt',
      isChecked: true,
      isDisabled: false,
    },
    {
      serviceTypeName: 'Maintenance',
      isChecked: true,
      isDisabled: false,
    },
    {
      serviceTypeName: 'ChargingStation',
      isChecked: true,
      isDisabled: false,
    },
  ],
};
